// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";


// TODO: Add SDKs for Firebase products that you want to us// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCmTa5vuVVv4Kd5-rUHv8Cj88ffNXpBnv8",
  authDomain: "achintya-orgz.firebaseapp.com",
  databaseURL: "https://achintya-orgz-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "achintya-orgz",
  storageBucket: "achintya-orgz.firebasestorage.app",
  messagingSenderId: "349293195234",
  appId: "1:349293195234:web:268da39a2a014f5e81d3bb",
  measurementId: "G-KQ22FM2CY7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const rtdb = getDatabase(app);    // Realtime Database
export const auth = getAuth(app);